import _ from 'underscore';

export const isUndefinedNullOrEmpty = (value) => {
    return value === undefined || value === null || value === '';
};

export const stringContains = (input, searchString) => {
    return input.indexOf(searchString) !== -1;
};

export const hasValue = (obj, valueToCheck) => {
    return _(_(obj).values()).contains(valueToCheck);
};

export const asCommaSeperatedString = (obj) => {
    return _(_(obj).values()).reduce((memo, state) => `${memo}, ${state}`);
};

//Combination of a few of these http://stackoverflow.com/questions/3765534/how-can-i-get-my-array-as-a-nice-human-readable-list-in-javascript
export const humanReadableListFrom = (array, join = ', ', finalJoin = ' and ') => {
    const arr = array.slice(0), last = arr.pop();
    const allButLast = arr.length > 0 ? arr.join(join) + finalJoin : '';
    return allButLast + last;    
};

export const stripTrailingSlash = (str) => {
    if(str.substr(-1) === '/') {
        return str.substr(0, str.length - 1);
    }

    return str;
};

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const guid = () => {
    const s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
};

export const convertToByteUnitLabel = (sizeInBytes) => {
    
    if (isUndefinedNullOrEmpty(sizeInBytes)){
        return 'unknown';
    }

    const mb = sizeInBytes / 1000.0 / 1000.0;
    const gb = mb / 1000.0;
    const tb = gb / 1000.0;

    if (tb > 1.5) {
        return tb.toFixed(2) + 'TB';
    } else if (gb > 1.5) {
        return gb.toFixed(2) + 'GB';
    } 
    return mb.toFixed(2) + 'MB';
};

export const sortByKey = (toSort, keySelector) => {
    return toSort.sort((a, b) => {
        const keyA = keySelector(a);
        const keyB = keySelector(b);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
    });
};

export const utcNowUnix = () => Math.floor((new Date()).getTime() / 1000);

export const formatDate = (date) => {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString() + ' at ' + dateObj.toLocaleTimeString();
};



// WEBPACK FOOTER //
// ./src/js/utils.js